import BaseAppNumber from '@/themes/base/components/atom/AppNumber'

export default {
  extends: BaseAppNumber,
  props: {
    showUnit: {
      Boolean,
      default: true,
    },
  },
  computed: {
    canDecrease() {
      const value = Number(this.value)

      return Number.isFinite(value) ? value > this.min : false
    },
  },
  methods: {
    minus() {
      if (!this.canDecrease) {
        return
      }

      return BaseAppNumber.methods.minus.call(this)
    },
  },
}
